import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createXeroInvoice, ordersQueryKeys, type XeroInvoiceMode } from '@api/orders';

export interface CreateXeroInvoiceVariables {
  orderId: number;
  mode?: XeroInvoiceMode;
}

export function useCreateXeroInvoice() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ orderId, mode }: CreateXeroInvoiceVariables) => createXeroInvoice(orderId, mode),
    onSuccess: () => {
      // The order now carries a xero_invoice_id — refresh it so the actions menu
      // swaps Generate for View + Regenerate (both the detail card and the list).
      queryClient.invalidateQueries({ queryKey: ordersQueryKeys.all });
    },
  });
}
